const locale = {
	"editor.remove": "Remove",
	"editor.copy": "Copy",
	"editor.words": "WORDS",
	"editor.characters": "Characters",
	"editor.default": "Default",
	"editor.recent": "Recently Used",
	"editor.nofill": "No Fill",
	"editor.format": "Format Painter",
	"editor.delete": "Delete",
	"editor.edit": "Edit",
	"editor.settings": "Settings",
	"editor.table_of_content": "Table of Content",
	"editor.draghandle.tooltip": "Modify",
	"editor.copyToClipboard": "CopyToClipboard",
	"editor.importWord.tooltip": "Import Word",
	"editor.slash": "Press '/' for commands",
	"editor.slash.empty": "No Result",
	"editor.slash.format": "Format",
	"editor.slash.insert": "Insert",
	"editor.slash.embed": "Embed Services",
	"editor.content": "Please input content",
	"editor.fontFamily.tooltip": "Font Family",
	"editor.fontFamily.default.tooltip": "Default Font Style",
	"editor.moremark": "More Text Styles",
	"editor.size.small.tooltip": "Small",
	"editor.size.medium.tooltip": "Medium",
	"editor.size.large.tooltip": "Cover",
	"editor.bold.tooltip": "Bold",
	"editor.italic.tooltip": "Italic",
	"editor.underline.tooltip": "Underline",
	"editor.strike.tooltip": "Strike",
	"editor.color.tooltip": "Color",
	"editor.color.more": "More Colors",
	"editor.highlight.tooltip": "Highlight",
	"editor.lineheight.tooltip": "Line Height",
	"editor.heading.tooltip": "Headings",
	"editor.heading.h1.tooltip": "Heading 1",
	"editor.heading.h2.tooltip": "Heading 2",
	"editor.heading.h3.tooltip": "Heading 3",
	"editor.heading.h4.tooltip": "Heading 4",
	"editor.heading.h5.tooltip": "Heading 5",
	"editor.heading.h6.tooltip": "Heading 6",
	"editor.paragraph.tooltip": "Paragraph",
	"editor.textalign.tooltip": "Align",
	"editor.textalign.left.tooltip": "Left",
	"editor.textalign.center.tooltip": "Center",
	"editor.textalign.right.tooltip": "Right",
	"editor.textalign.justify.tooltip": "Justify",
	"editor.indent": "Indent",
	"editor.indent.indent": "Increase Indent",
	"editor.indent.outdent": "Decrease Indent",
	"editor.fontSize.tooltip": "Font size",
	"editor.fontSize.default.tooltip": "Default Font Size",
	"editor.superscript.tooltip": "Superscript",
	"editor.subscript.tooltip": "Subscript",
	"editor.bulletlist.tooltip": "Bullet List",
	"editor.orderedlist.tooltip": "Ordered List",
	"editor.tasklist.tooltip": "Task List",
	"editor.indent.tooltip": "Indent",
	"editor.outdent.tooltip": "Outdent",
	"editor.columns.tooltip": "Columns",
	"editor.link.tooltip": "Link",
	"editor.link.unlink.tooltip": "UnLink",
	"editor.link.open.tooltip": "Open Link",
	"editor.link.edit.tooltip": "Edit Link",
	"editor.link.dialog.title": "Insert Link",
	"editor.link.dialog.link": "Link",
	"editor.link.dialog.text": "Text",
	"editor.link.dialog.openInNewTab": "Open In New Tab",
	"editor.link.dialog.link.placeholder": "Link Address",
	"editor.link.dialog.text.placeholder": "Add Description",
	"editor.link.dialog.button.apply": "Apply",
	"editor.image.tooltip": "Image",
	"editor.image.dragger.tooltip": "Click or drag the image to the area to upload",
	"editor.image.float.left.tooltip": "Float left",
	"editor.image.float.none.tooltip": "Float none",
	"editor.image.float.right.tooltip": "Float right",
	"editor.image.dialog.title": "Add an image",
	"editor.image.dialog.tab.url": "Url",
	"editor.image.dialog.tab.upload": "Upload",
	"editor.image.dialog.uploading": "Uploading",
	"editor.image.dialog.form.link": "Link",
	"editor.image.dialog.placeholder": "Link",
	"editor.image.dialog.form.alt": "Alt",
	"editor.image.dialog.form.aspectRatio": "Lock original aspect ratio",
	"editor.image.dialog.form.file": "File",
	"editor.image.dialog.button.apply": "apply",
	"editor.video.tooltip": "Video",
	"editor.video.dialog.tab.upload": "Upload",
	"editor.video.dialog.uploading": "Uploading",
	"editor.video.dialog.title": "Embed a video",
	"editor.video.dialog.link": "Link",
	"editor.video.dialog.placeholder": "Link",
	"editor.video.dialog.button.apply": "Apply",
	"editor.table.tooltip": "Table",
	"editor.table.menu.insert_table": "Insert Table",
	"editor.table.menu.insert_table.with_header_row": "With header row",
	"editor.table.menu.add_column_before": "Add Column Before",
	"editor.table.menu.add_column_after": "Add Column After",
	"editor.table.menu.delete_column": "Delete Column",
	"editor.table.menu.add_row_before": "Add Row Before",
	"editor.table.menu.add_row_after": "Add Row After",
	"editor.table.menu.delete_row": "Delete Row",
	"editor.table.menu.merge_or_split_cells": "Merge Or Split Cells",
	"editor.table.menu.delete_table": "Delete Table",
	"editor.blockquote.tooltip": "Blockquote",
	"editor.horizontalrule.tooltip": "Horizontal Rule",
	"editor.code.tooltip": "Code",
	"editor.codeblock.tooltip": "Code Block",
	"editor.clear.tooltip": "Clear Format",
	"editor.undo.tooltip": "Undo",
	"editor.redo.tooltip": "Redo",
	"editor.fullscreen.tooltip.fullscreen": "Fullscreen",
	"editor.fullscreen.tooltip.exit": "Fullscreen Exit",
	"editor.imageUpload.fileTypeNotSupported": "File type not supported",
	"editor.imageUpload.fileSizeTooBig": "File size too big, Maximum size is",
	"editor.table.menu.insertColumnBefore": "Insert Column Before",
	"editor.table.menu.insertColumnAfter": "Insert Column After",
	"editor.table.menu.deleteColumn": "Delete Column",
	"editor.table.menu.insertRowAbove": "Insert Row Above",
	"editor.table.menu.insertRowBelow": "Insert Row Below",
	"editor.table.menu.deleteRow": "Delete Row",
	"editor.table.menu.mergeCells": "Merge Cells",
	"editor.table.menu.splitCells": "Split Cells",
	"editor.table.menu.deleteTable": "Delete Table",
	"editor.table.menu.setCellsBgColor": "Cell Background Color",
	"editor.emoji.tooltip": "Emoji",
	"editor.iframe.tooltip": "Iframe",
	"editor.searchAndReplace.tooltip": "Search and Replace",
	"editor.search.dialog.text": "Search",
	"editor.replace.dialog.text": "Replace",
	"editor.replaceAll.dialog.text": "Replace All",
	"editor.previous.dialog.text": "Previous",
	"editor.next.dialog.text": "Next",
	no_result_found: "No results found",
	"Smileys & People": "Smileys & People",
	"Animals & Nature": "Animals & Nature",
	"Food & Drink": "Food & Drink",
	Activity: "Activity",
	"Travel & Places": "Travel & Places",
	Object: "Objects",
	Symbol: "Symbols",
	Flags: "Flags",
	"Frequently used": "Frequently used",
	"editor.formula.dialog.text": "Formula",
	"editor.katex.tooltip": "Math Formula",
	"editor.exportPdf.tooltip": "Export PDF",
	"editor.exportWord.tooltip": "Export Word",
	"editor.importWrod.tooltip": "Import Word",
	"editor.variableInsert.default.tooltip": "Insert variable"
};

export default locale;
